import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import saveAs from 'file-saver';
import { DataService } from 'src/app/common/data.service';

export interface DialogData {
  Attachment: any;
  Count: any;
  fieldName: string;
  filefordelete: string;
  IsFormEditable: boolean;
  ModuleName: string;
  ApprovalStatus: number;
  CanAttachAfterSubmit: boolean;
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {

  AttachmentsGroup: any;
  file: File;
  formData: FormData = new FormData();
  LocalAttachments: any;
  stringArray: any;
  IsApproved: boolean;

  constructor(public dialogRef: MatDialogRef<FileUploadComponent>,
    private _dataService: DataService,
    @Inject(MAT_DIALOG_DATA) public _data: DialogData) { }

  ngOnInit() {
    this.IsApproved = false;
    this.AttachmentsGroup = [];
    this.stringArray = [];
    if (this._data.Count > 0) {
      this.LocalAttachments = [];
      for (const entry of this._data.Attachment) {
        const fileExtension = entry.substring(entry.lastIndexOf('.') + 1);
        this.stringArray = entry.split('_');
        const newName = this.stringArray.slice(2).join('_');
        let newFileName = '';
        if (newName.lastIndexOf('_') === -1) {
          newFileName = newName;
        } else {
          newFileName = newName; // .substring(0, newName.lastIndexOf('_')) + '.' + fileExtension;
        }

        this.LocalAttachments.push({ 'File': newFileName, 'FullName': entry });
      }
    } else {
      this.LocalAttachments = [];
      this._data.Attachment = [];
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  UploadAttachment(event) {

    if (event.target.files.length > 0) {
      const fileList: FileList = event.target.files;
      const file: File = fileList[0];
      const maxLength = 1024 * 1024 * 10;
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (fileExtension.toLowerCase() === 'docx' || fileExtension.toLowerCase() === 'doc'
        || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'zip'
        || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'jpg'
        || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'png'
        || fileExtension.toLowerCase() === 'msg') {
        this.formData = new FormData();
        if (event.target.files[0].size > maxLength) {
          alert('File size can not be more than 10 mb.');
          event.target.value = '';
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this._dataService.postfile('Attachment/UploadAttachment/' + 10, this.formData).subscribe(path => {
          if (path['RequestIsSuccess']) {
            this.LocalAttachments.push({ 'File': file.name, 'FullName': path['RequestMessage'] });
            this._data.Attachment.push(path['RequestMessage']);
          } else {
            alert(path['RequestMessage']);
          }
        },
          (error) => { },
          () => { });
      } else {
        alert('Please browse valid file extension.');
        event.target.value = '';
      }
    }
  }

  DeleteAttachment(attachmentName: string) {
    if (confirm('Are you sure?')) {
      this.stringArray = attachmentName.split('_');
      const attachmentID = this.stringArray.slice(0, 1).join('_');
      if (attachmentID !== '0') {
        this._dataService.GetDataById('Attachment/DeleteAttachment', attachmentID).subscribe(x => {
          this.LocalAttachments = this.LocalAttachments.filter(res => res.FullName !== attachmentName);
          this._data.Attachment = this._data.Attachment.filter(res => res !== attachmentName);
        });
      } else {
        this.LocalAttachments = this.LocalAttachments.filter(x => x.FullName !== attachmentName);
        this._data.Attachment = this._data.Attachment.filter(x => x !== attachmentName);
      }
    }
  }

  DownloadFile(attachmentName: string, fileName: string) {
    // const attachmentID = attachmentName.substring(0, 4);
    const downloadURL = 'Attachment/DownloadAllAttachmentByName?attachmentName=' + attachmentName;
    this._dataService.DownloadFile(downloadURL).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, fileName);
    });
  }

}
